<template>
  <v-card class="widget-card" rounded="2" :class="{ 'disabled-widget': isDisabled }">
    <div class="card-header" v-if="!!title">
      <span>{{ title }}</span>
      <slot name="title-append" />
    </div>
    <div class="card-body" :class="isState && 'state-widget'">
      <template v-if="!isLoading">
        <slot>
          <slot name="stat" />
          <Chart :data="data" v-if="data" />
          {{ value }}
        </slot>
      </template>

      <AppLoader v-else :size="35" :width="4" />
    </div>
    <div class="disabled-overlay" />

    <div class="coming-soon" v-if="isComingSoon">
      <span class="coming-soon-label"> {{ $t("coming_soon") }} </span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "Widget",

  data() {
    return {
      chartModule: null,
      isLoading: true,
      options: null,
    };
  },

  props: {
    title: {
      type: String,
      default: null,
    },

    state: {
      type: String,
      default: null,
    },

    desc: {
      type: String,
      default: null,
    },

    data: {
      type: Object,
      default: () => null,
    },

    isState: {
      type: Boolean,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    isComingSoon: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.isLoading = false;
    });
  },
};
</script>
<style src="./styles.scss" lang="scss" scoped></style>
